import SnackbarView from './SnackbarView';

export default SnackbarView;
